import styled from "styled-components";

export const FormErrors = styled.div`
border: 1px solid var(--ikon-error-color, #c00);
padding: 0.7em 1em;
text-align: center;
a {
  text-decoration: underline;
}
${(props) =>
  props.theme.apply("default", (breakpoint: string) => {
    return `
        margin-top: ${props.theme.spacePx(breakpoint, 7)};
        ${props.theme.textStyle(breakpoint, "body")};
        
      `;
  })}

  &:empty {
    display: none;
  }
`;